import { Component } from '@angular/core';
import {DeviceSectorization, DeviceSectorizationType} from "../../../models/grit/grit.device-model";
import {CalculationsControlService} from "../../../services/calculations-control.service";
import {ConfigurationService} from "../../../services/configuration.service";
import {BsModalRef} from "ngx-bootstrap/modal";
import {MapService} from "../../../services/map.service";
import {PointsService} from "../../../services/points.service";
import {ModalControlService} from "../../../services/modal-control.service";
import {ProjectService} from "../../../services/project.service";
import {GritInterferenceTestDeviceService} from "../../../services/grit/grit.interference-test-device.service";
import {indexOf} from "lodash";
import {Subject} from "rxjs";
import {MatTabGroup} from '@angular/material/tabs';

@Component({
  selector: 'app-add-device-sectorization',
  templateUrl: './add-device-sectorization.component.html',
  styleUrls: ['./add-device-sectorization.component.scss','../../../app.component.scss'],
  standalone: false
})
export class AddDeviceSectorizationComponent {
  sectorization : DeviceSectorization = new DeviceSectorization();

  public onClose: Subject<DeviceSectorization> = new Subject<DeviceSectorization>();

  constructor(
              public configurationService : ConfigurationService,
              public bsModalRef : BsModalRef,
              public mapService : MapService,
              public pointsService : PointsService,
              ) {}

  cancel(){
    this.bsModalRef.hide();
    this.bsModalRef.onHidden.subscribe(() =>{
      this.onClose.complete();
    })
  }

  add(){
    this.bsModalRef.hide();

    this.bsModalRef.onHidden.subscribe(() =>{
      this.onClose.next(this.sectorization);
      this.onClose.complete();
    })
  }

  protected readonly MAT_LEGACY_TAB_GROUP = MatTabGroup;
  protected readonly DeviceSectorizationType = DeviceSectorizationType;
  protected readonly Object = Object;
  protected readonly Number = Number;
}
